import { FormulaireAutorisationIntervention } from './formulaireAutorisationIntervention.model';
import { Piece } from './piece.model';
import {DossierIntervention} from './dossier_intervention.model';

export class FicheIntervention {
    id: number;
    dossier_intervention_id: string;
    date_contact: string;
    date_intervention: string;
    categorie_intervention: string;
    contenu_rapporte_urgex: string;
    travaux_a_effectuer: string;
    cause_sinistre: string;
    recommendation: string;
    camion_usine: string;
    debris_type_equipement_id: number;
    debris_quantite: string;
    sacs_ordure: number;
    pieces: Piece[];
    eau_aspire: string;
    pompe_submersible: string;
    nettoyage: string;
    dossier_intervention: DossierIntervention;
    tyvek: number;
    mask: number;
    tapis_de_protection: number;
    couverture: number;
    polythene: string;
    protection: string;
    hauteur: string;
    largeur: string;
    restriction_zone: string;

    public constructor(init?: Partial<FicheIntervention>) {
      Object.assign(this, init);
    }
  }
